/* prodnamo — "window cards" facon soundscience.
   Ajoute une barre de titre (3 points + label mono + reference) en haut de
   certaines sections, pour un look "fenetre OS". N'ecrase ni ne deplace le
   contenu : la barre est superposee (position absolue, pointer-events:none).

   >>> Pour editer les titres / cibler d'autres sections : modifie PN_WIN_CONFIG.
       - sel     : selecteur de l'element a encadrer (le conteneur de la section)
       - title   : texte de la barre (ex: "© LATEST_RELEASE", "// FAQ", "© BEATS")
       - clip    : true = rogne le contenu aux coins (a eviter si media zoomable)
       - mTop    : MARGE EXTERNE au-dessus de la fenetre, en px (defaut 24)
       - mBottom : MARGE EXTERNE en dessous de la fenetre, en px (defaut 24)
       - pad     : 'none' = ne touche a rien (padding+marge geres ailleurs ;
                   utilise pour le carrousel qui a ses propres reglages).

   >>> INTERNE vs EXTERNE (independants) :
       - Le PADDING INTERNE (qui agrandit la fenetre) = le reglage "Marge haute/basse"
         natif de la section, dans le customizer. Min 48px en haut pour la barre.
       - La MARGE EXTERNE (espace autour de la fenetre) = mTop / mBottom ci-dessous.
       Tu regles donc les deux separement. */

(function () {
  'use strict';

  var PN_WIN_CONFIG = [
    { sel: '.section-featured-product .page-width',              title: '© LATEST_RELEASE', clip: false, mTop: 24, mBottom: 24 },
    { sel: '.section-collection-list .collection-list-wrapper',  title: '© COLLECTIONS',    clip: true,  mTop: 24, mBottom: 24 },
    { sel: '.multicolumn .page-width',                           title: '// WHAT_YOU_GET',  clip: true,  mTop: 24, mBottom: 24 },
    { sel: '.pn-marquee-section .pn-marquee__viewport',          title: '© DRUMKITS',       clip: true,  pad: 'none'          },
    { sel: '.pricing-plans .page-width',                         title: '© LICENSES',       clip: false, mTop: 24, mBottom: 24 },
    { sel: '.collapsible-content-wrapper-narrow',                title: '// FAQ',           clip: true,  mTop: 24, mBottom: 24 }
  ];

  var PN_MIN_TOP = 48;   // place minimale pour la barre de titre
  var PN_MIN_BOTTOM = 26; // respiration minimale en bas

  // reference stable (pas d'aleatoire qui change a chaque rechargement)
  function refFrom(str) {
    var h = 0, i;
    for (i = 0; i < str.length; i++) {
      h = (h * 31 + str.charCodeAt(i)) | 0;
    }
    h = Math.abs(h).toString();
    while (h.length < 10) { h = h + h; }
    return 'REF_' + h.slice(0, 10);
  }

  function buildBar(title, ref) {
    var bar = document.createElement('div');
    bar.className = 'pn-win__bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<span class="pn-win__dots"><i></i><i></i><i></i></span>' +
      '<span class="pn-win__title"></span>' +
      '<span class="pn-win__meta"></span>';
    bar.querySelector('.pn-win__title').textContent = title;
    bar.querySelector('.pn-win__meta').textContent = ref;
    return bar;
  }

  // detecte si Dawn applique son padding de section sur CET element
  // (classe generee du type "section-...-padding")
  function hasDawnPadding(el) {
    for (var i = 0; i < el.classList.length; i++) {
      var c = el.classList[i];
      if (c.length >= 8 && c.indexOf('-padding') === c.length - 8) { return true; }
    }
    return false;
  }

  function applyPad(el, cfg) {
    if (cfg.pad === 'none') { return; }

    // Surcharges posees par la section (curseurs du customizer) : prioritaires.
    //   data-pn-pt / data-pn-pb = padding INTERNE (haut / bas)
    //   data-pn-mt / data-pn-mb = marge EXTERNE (haut / bas)
    // un attribut absent OU vide ("") est considere comme non defini
    function attr(name) {
      var v = el.getAttribute(name);
      return (v === null || v === '') ? null : v;
    }
    var opt = attr('data-pn-pt');
    var opb = attr('data-pn-pb');
    var omt = attr('data-pn-mt');
    var omb = attr('data-pn-mb');

    // INTERNE (agrandit la fenetre, min garanti pour la barre)
    if (opt !== null || opb !== null) {
      el.style.paddingTop = Math.max(parseFloat(opt) || 0, PN_MIN_TOP) + 'px';
      el.style.paddingBottom = Math.max(parseFloat(opb) || 0, PN_MIN_BOTTOM) + 'px';
    } else if (hasDawnPadding(el)) {
      // sinon : on reprend le padding natif de la section (capture UNE fois avant
      // modif ; en editeur un changement recharge la section -> DOM neuf -> recapture).
      if (!el.hasAttribute('data-pn-cap-t')) {
        var cs = getComputedStyle(el);
        el.setAttribute('data-pn-cap-t', parseFloat(cs.paddingTop) || 0);
        el.setAttribute('data-pn-cap-b', parseFloat(cs.paddingBottom) || 0);
      }
      el.style.paddingTop = Math.max(parseFloat(el.getAttribute('data-pn-cap-t')) || 0, PN_MIN_TOP) + 'px';
      el.style.paddingBottom = Math.max(parseFloat(el.getAttribute('data-pn-cap-b')) || 0, PN_MIN_BOTTOM) + 'px';
    }

    // EXTERNE : marge autour de la fenetre, independante du padding interne.
    var mt = (omt !== null) ? (parseFloat(omt) || 0) : (cfg.mTop == null ? 24 : cfg.mTop);
    var mb = (omb !== null) ? (parseFloat(omb) || 0) : (cfg.mBottom == null ? 24 : cfg.mBottom);
    el.style.marginTop = mt + 'px';
    el.style.marginBottom = mb + 'px';
  }

  function apply() {
    PN_WIN_CONFIG.forEach(function (cfg) {
      var els = document.querySelectorAll(cfg.sel);
      els.forEach(function (el, idx) {
        // idempotent : on nettoie une eventuelle barre precedente
        var old = el.querySelector(':scope > .pn-win__bar');
        if (old) { old.remove(); }

        applyPad(el, cfg);

        el.classList.add('pn-win');
        if (cfg.clip) { el.classList.add('pn-win--clip'); }
        // titre par-instance : data-pn-title (pose par la section) prioritaire sur
        // le titre du config -> chaque carrousel affiche son propre label.
        var title = el.getAttribute('data-pn-title') || cfg.title;
        var ref = refFrom(cfg.sel + '#' + idx + '#' + title);
        el.prepend(buildBar(title, ref));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // re-applique quand une section est rechargee dans l'editeur de theme
  document.addEventListener('shopify:section:load', apply);
})();


/* ============================================================
   FAQ : ouverture / fermeture fluides.
   Le <details> reste TOUJOURS ouvert : le contenu est deja mis en page
   (polices, texte...), cache dans un conteneur a hauteur 0. Au clic on
   n'anime que la hauteur de ce conteneur -> rien a construire au depart,
   donc pas de saccade sur les premieres frames. L'etat visuel (fleche,
   aria-expanded) est porte par la classe .is-open sur le <details>.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 420;
  var EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';   // meme expo-out que le reste du site

  function bind(details) {
    if (details.__pnFaqBound) { return; }
    details.__pnFaqBound = true;
    var summary = details.querySelector('summary');
    var content = summary ? summary.nextElementSibling : null;
    if (!summary || !content) { return; }

    // conteneur anime autour du contenu (le contenu garde ses marges dedans)
    var wrap = document.createElement('div');
    wrap.className = 'pn-faq-wrap';
    details.insertBefore(wrap, content);
    wrap.appendChild(content);

    var isOpen = details.open;
    details.open = true;                       // toujours ouvert cote navigateur
    details.classList.toggle('is-open', isOpen);
    summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    wrap.style.height = isOpen ? 'auto' : '0px';

    var anim = null;
    function setOpen(open) {
      details.classList.toggle('is-open', open);
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (reduce || typeof wrap.animate !== 'function') { wrap.style.height = open ? 'auto' : '0px'; return; }

      var from = wrap.getBoundingClientRect().height;   // etat courant (meme en pleine anim)
      if (anim) { anim.cancel(); anim = null; }
      var to = open ? wrap.scrollHeight : 0;            // deja mis en page : mesure gratuite
      wrap.style.height = from + 'px';
      anim = wrap.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: DURATION, easing: EASING });
      anim.onfinish = function () { anim = null; wrap.style.height = open ? 'auto' : '0px'; };
      anim.oncancel = function () { anim = null; };
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();                      // le <details> ne doit jamais se refermer lui-meme
      setOpen(!details.classList.contains('is-open'));
    });
  }

  function initFaq() {
    document.querySelectorAll('.collapsible-content details').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaq);
  } else {
    initFaq();
  }
  document.addEventListener('shopify:section:load', initFaq);
})();
